import { GoabText } from '@abgov/angular-components';
import { CommonModule } from '@angular/common';
import { Component, effect, input, output, signal } from '@angular/core';
import {
  MatFormField,
  MatOption,
  MatSelect,
  MatSelectTrigger,
} from '@angular/material/select';
import { NumberToWordsPipe } from '../../../../shared/pipes/number-to-words.pipe';

@Component({
  selector: 'app-reasons-for-change',
  imports: [
    CommonModule,
    GoabText,
    MatFormField,
    MatSelect,
    MatOption,
    MatSelectTrigger,
    NumberToWordsPipe,
  ],
  templateUrl: './reasons-for-change.component.html',
  styleUrl: './reasons-for-change.component.scss',
})
export class ReasonsForChangeComponent {
  readonly reasons: string[] = [
    'Staffing shortage / added staff',
    'Maintenance issues / maintenance completed',
    'Outbreak management / outbreak resolved',
    'Emergency closure / reopened after closure',
    'Other',
  ];

  constructor() {
    effect(() => {
      this.selectedReasons.set(this.existingReasons() || []);
    });
  }

  existingReasons = input<string[] | undefined>(undefined);
  disabled = input<boolean>(true);
  selectionChanged = output<string[]>();

  protected selectedReasons = signal<string[]>([]);

  onOpenedChange(opened: boolean) {
    if (!opened) {
      this.selectionChanged.emit(this.selectedReasons());
    }
  }

  onValueChange(value: string[]) {
    this.selectedReasons.set(value);
  }
}
